import React, { Fragment, useState } from 'react'
import CustomizedDialogs from '../../atoms/dialog'
import { Button, CircularProgress, Typography } from '@material-ui/core'
import { handleSnackBar, handleTopRightInfo } from '../../../store/global/actions';
import { downloadBlueprintZip, exportBlueprintJson } from '../../../store/blueprint/actions';
import { useDispatch } from 'react-redux';

export default function BlueprintExportDialog({isOpen=false, selectedItem, setActiveDialog}) {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(isOpen);
	const [exportLoader, setExportLoader] = useState(false);
	
    const toggleExportConfirmation = (event) => {
        if(open){
            setActiveDialog(null)
        }
        setOpen((prev) => !prev)
    };

	const onExport = async (event) => {
		setExportLoader(true);
		dispatch(handleTopRightInfo({ message: "Exporting the blueprint..", open: true, }));

		// export of react-redux store data
		await dispatch(exportBlueprintJson(selectedItem?.title, selectedItem)).then((response) => {

			const exportResponse = JSON.parse(JSON.stringify(response));
			console.log("export json resp: ", exportResponse)

			if(exportResponse.status){
				dispatch(handleTopRightInfo({ message: "", open: false, }));
				setExportLoader(false);
				toggleExportConfirmation();
				dispatch(handleSnackBar({ open: true, message: 'Blueprint is prepared. Downloading started.', severity: "info" }));

				const filePath = exportResponse?.data?.filePath;
				if(filePath != undefined){
					dispatch(downloadBlueprintZip(selectedItem, filePath));
				}
			}else{
				console.error(exportResponse.message)
			}

		})
        setActiveDialog(null)
	};
  return (
    <CustomizedDialogs
		open={open}
		title="Export Blueprint"
		handleClose={toggleExportConfirmation}
		container_id="export-blueprint"
		actions={
			<React.Fragment>
				<Button autoFocus onClick={toggleExportConfirmation} variant="outlined" color="primary" style={{textTransform: 'capitalize'}}>
					Close
				</Button>
				<Button autoFocus variant="contained" color="primary" onClick={onExport} disabled={exportLoader} startIcon={exportLoader ? <CircularProgress color="secondary" size={20} /> : <Fragment />} style={{textTransform: 'capitalize'}}>
					{exportLoader ? 'Exporting...' : 'Export'}
				</Button>
			</React.Fragment>
		}
	>
		<Typography>Do you want to export the selected blueprint?</Typography>
	</CustomizedDialogs>
  )
}
